import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import { Button } from '@web-components-proxy';

interface SearchInputClearButtonProps {
	touched: boolean;
	btnHandler: () => void;
}

export const SearchInputSearchButton: FunctionComponent<SearchInputClearButtonProps> = memo(
	({ touched, btnHandler }) => {
		return (
			<Button
				tabIndex={-1}
				onClick={btnHandler}
				class="search-input__button"
				design="primary"
				size="small"
				disabled={!touched}
			>
				Search
			</Button>
		);
	},
);
